module.exports = __webpack_public_path__ + "static/media/JP.a011dca3.svg";